import "./DamienCole.module.css";
import MainNavigation from "@/reusable_sections/Header";
import IgniteYourLeadership from "./sections/IgniteYourLeadership";
import TheStageExperience from "./sections/TheStageExperience";
import SignatureKeynoteTopics from "./sections/SignatureKeynoteTopics";
import SpeakerToolkit from "./sections/SpeakerToolkit";
import VoicesOfImpact from "./sections/VoicesOfImpact";
import SecureYourDate from "./sections/SecureYourDate";
import Footer from "@/reusable_sections/Footer";
export default function DamienColePage() {
  return <div>
      <MainNavigation />
      <IgniteYourLeadership />
      <TheStageExperience />
      <SignatureKeynoteTopics />
      <SpeakerToolkit />
      <VoicesOfImpact />
      <SecureYourDate />
      <Footer />
    </div>;
}